import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { get, isEmpty } from 'underscore';

import { reactFormValidators } from 'modules/validation';
import useI18n from 'hooks/I18n/useI18n.js';

import Input, { ERROR_MODE } from 'src/components/atoms/Input/Input.jsx';
import Label from 'src/components/atoms/Label/Label.jsx';
import Button from 'src/components/atoms/Button/Button.jsx';
import Link from 'src/components/atoms/Link/Link.jsx';
import Text from 'src/components/atoms/Text/Text.jsx';
import Title from 'src/components/atoms/Title/Title.jsx';

const ForgotPassword = ({ onSubmit }) => {
    const { trans } = useI18n();
    const { register, watch, handleSubmit, formState } = useFormContext();
    const { assertValidEmail } = reactFormValidators(trans);
    const { isSubmitting, errors } = formState;
    const mailProps = {
        mode: errors.email && ERROR_MODE,
        error: get(errors, ['email', 'message']),
        ...register('email', { validate: assertValidEmail('email') }),
    };

    const mailValue = watch('email');

    return (
        <div className="nd-forgot-password-container">
            <Title level="3">{trans('login.forgotPassword')}</Title>
            <Text>{trans('login.askForNewPasswordDetails')}</Text>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Label htmlFor="email">{trans('login.email')}</Label>
                <Input {...mailProps} id="email"></Input>
                <Button disabled={isSubmitting || isEmpty(mailValue)} type="submit">
                    {trans('global.submit.send')}
                </Button>
            </form>
            <Text>
                <Link to="/login">{trans('login.backToLogin')}</Link>
            </Text>
        </div>
    );
};

ForgotPassword.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default ForgotPassword;
